<p-dropdown 
  [options]="records$ | async" 
  [(ngModel)]="selectedRecord" 
  (ngModelChange)="selectedRecordChanged()"
  optionValue="id"
  optionLabel="description"
  [ngClass]="{'ng-invalid ng-dirty': shouldShowError }" 
  appendTo="body">
</p-dropdown>